"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var oidc_client_1 = require("oidc-client");
var services_1 = require("../services");
var SilentCallback = function (_a) {
    var logger = _a.logger;
    react_1.useEffect(function () {
        new oidc_client_1.UserManager({}).signinSilentCallback();
        logger.info('callback silent signin successfull');
    });
    return react_1.default.createElement("div", null);
};
SilentCallback.defaultProps = {
    logger: services_1.oidcLog,
};
exports.default = SilentCallback;
